import Lenis from "lenis";

let lenis = null;

export function initLenis() {
  if (lenis) return lenis;
  if (localStorage.getItem("gb-a11y") === "1") return null; // modalità accessibile: scroll nativo
  const instance = new Lenis({ lerp: 0.09, smoothWheel: true });
  lenis = instance;
  function raf(time) {
    if (lenis !== instance) return; // istanza distrutta (modalità accessibile): ferma il loop
    instance.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
  return instance;
}

export function setA11yMode(on) {
  if (on) {
    if (lenis) {
      lenis.destroy();
      lenis = null;
    }
  } else {
    initLenis();
  }
}

export function scrollToSection(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function scrollToTop() {
  if (lenis) lenis.scrollTo(0, { immediate: true });
  window.scrollTo(0, 0);
}

export function scrollToPos(y) {
  if (lenis) lenis.scrollTo(y, { immediate: true });
  window.scrollTo(0, y);
}

// blocca lo scroll della pagina (overlay fullscreen): ferma Lenis e il body
export function lockScroll(on) {
  if (lenis) {
    if (on) lenis.stop();
    else lenis.start();
  }
  document.body.style.overflow = on ? "hidden" : "";
}
